import Vue from "vue";
import Vuetify from "vuetify";

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: "#0a4537",
                secondary: "#f7941d",
                accent: "#000000",
                error: "#ed1d25",
                info: "#2196F3",
                success: "#4CAF50",
                warning: "#f7941d",
            },
            dark: {
                primary: "#0a4537",
                secondary: "#f7941d",
                accent: "#000000",
                error: "#ed1d25",
                info: "#2196F3",
                success: "#4CAF50",
                warning: "#f7941d",
            },
        },
    },
    icons: {
        iconfont: "md",
    },
});
